
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取祭拜记录列表集合
    GetSacrificeLogSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/SacrificeLog/SacrificeLogSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetSacrificeLogSearchList2({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/SacrificeLog/SacrificeLogSearch2',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取祭拜详情
    GetSacrificeLogSacrificeLogById({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/SacrificeLog/GetSacrificeLogById',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetSacrificeLogListByMid({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/SacrificeLog/GetSacrificeLogListByMid',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
